import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategorySection() {
  return (
    <section className="py-10 md:py-14 bg-background-900">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading mb-2">影片分类</h2>
          <p className="text-sm text-foreground-500">探索各种类型的日韩电影，找到你最爱的片单</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-800/50 rounded-lg border border-background-700/50 hover:border-primary-500/50 hover:bg-background-800 transition-all duration-300 cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-400 group-hover:bg-primary-500 group-hover:text-background-950 transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-200 group-hover:text-foreground-50 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}